import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
import { VerticalStack } from './Stack';
import { SectionEyebrow } from './Typography';

export interface PaneHeaderProps {
  title: string;
  subtitle?: string;
  badges?: React.ReactNode;
  onClear?: () => void;
  className?: string;
  sticky?: boolean;
}

export function PaneHeader({
  title,
  subtitle,
  badges,
  onClear,
  className,
  sticky = true,
}: PaneHeaderProps) {
  return (
    <header
      className={cn(
        'shrink-0 border-b border-border/50 bg-muted/5 px-6 py-8',
        sticky && 'sticky top-0 z-10',
        className
      )}
    >
      <div className="flex items-start justify-between">
        <VerticalStack gap={2} className="min-w-0">
          <h2 className="font-heading text-xl font-black uppercase tracking-tight text-foreground leading-none">
            {title}
          </h2>
          {subtitle && (
            <SectionEyebrow className="text-primary/80">
              {subtitle}
            </SectionEyebrow>
          )}
        </VerticalStack>
        {onClear && (
          <button
            onClick={onClear}
            className="p-2 -mt-2 -mr-2 rounded-full hover:bg-muted text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close panel"
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>

      {badges && <div className="mt-6 flex flex-wrap gap-2">{badges}</div>}
    </header>
  );
}
